define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: reset default custom view based on new context
			this.widget.refreshDefaultCustomView();
		}
	});
});